var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCandlestick = function SvgCandlestick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.25 3.25V1h1.5v2.25zm0 15.75v-6.25h1.5V19z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.75 3.25h4.5v9.5h-4.5zm1.5 1.5v6.5h1.5v-6.5z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.75 3.25h4.5v9.5h-4.5zm1.5 1.5v6.5h1.5v-6.5z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.75 17.75V19h-1.5v-1.25zm0-16.75v11.25h-1.5V1z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.25 17.75h-4.5v-5.5h4.5zm-1.5-1.5v-2.5h-1.5v2.5z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.25 4.25V1h1.5v3.25zm0 14.75v-3.25h1.5V19z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.75 4.25h4.5v11.5h-4.5zm1.5 1.5v8.5h1.5v-8.5z",
    clipRule: "evenodd"
  })));
};
export { SvgCandlestick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxwYXRoIG9wYWNpdHk9Ii41IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuMjUgMy4yNVYxaDEuNXYyLjI1aC0xLjVaTTMuMjUgMTl2LTYuMjVoMS41VjE5aC0xLjVaIiAvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS43NSAzLjI1aDQuNXY5LjVoLTQuNXYtOS41Wm0xLjUgMS41djYuNWgxLjV2LTYuNWgtMS41WiIgLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEuNzUgMy4yNWg0LjV2OS41aC00LjV2LTkuNVptMS41IDEuNXY2LjVoMS41di02LjVoLTEuNVoiIC8+PHBhdGggb3BhY2l0eT0iLjUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNzUgMTcuNzVWMTloLTEuNXYtMS4yNWgxLjVaTTEwLjc1IDF2MTEuMjVoLTEuNVYxaDEuNVoiIC8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi4yNSAxNy43NWgtNC41di01LjVoNC41djUuNVptLTEuNS0xLjV2LTIuNWgtMS41djIuNWgxLjVaIiAvPjxwYXRoIG9wYWNpdHk9Ii41IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1LjI1IDQuMjVWMWgxLjV2My4yNWgtMS41Wk0xNS4yNSAxOXYtMy4yNWgxLjVWMTloLTEuNVoiIC8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy43NSA0LjI1aDQuNXYxMS41aC00LjVWNC4yNVptMS41IDEuNXY4LjVoMS41di04LjVoLTEuNVoiIC8+PC9zdmc+";